import { useState } from 'react';
import { FiDownload, FiBookOpen, FiLoader } from 'react-icons/fi';

export default function SharePointSetupGuide() {
  const [downloading, setDownloading] = useState(false);

  const handleDownload = async () => {
    setDownloading(true);
    try {
      const { generateSharePointSetupGuide } = await import('../lib/generateSetupGuide');
      await generateSharePointSetupGuide();
    } catch (err) {
      console.error('Failed to generate PDF:', err);
    } finally {
      setDownloading(false);
    }
  };

  return (
    <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6">
      <div className="flex items-start justify-between">
        <div className="flex items-start space-x-3">
          <FiBookOpen className="w-5 h-5 text-blue-600 mt-0.5 flex-shrink-0" />
          <div>
            <h4 className="text-sm font-medium text-blue-900">
              SharePoint Integration Setup Guide
            </h4>
            <p className="text-sm text-blue-700 mt-1">
              Download the step-by-step guide for configuring Azure AD app registration
              and connecting SharePoint to Doxolve.
            </p>
          </div>
        </div>
        <button
          onClick={handleDownload}
          disabled={downloading}
          className="inline-flex items-center px-3 py-1.5 text-sm bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors whitespace-nowrap flex-shrink-0 ml-4 disabled:opacity-50"
        >
          {downloading ? (
            <FiLoader className="w-4 h-4 mr-1.5 animate-spin" />
          ) : (
            <FiDownload className="w-4 h-4 mr-1.5" />
          )}
          {downloading ? 'Generating...' : 'Download PDF'}
        </button>
      </div>
    </div>
  );
}
